import { Auth } from './Auth.js'
import { Rates } from './Rates.js'
import { Dashboard } from './Dashboard.js'

export default [
    Auth,
    Rates,
    Dashboard
]
